import { defineStore } from "pinia";
import { useQuery } from "@vue/apollo-composable";
import { fetchCurrentPage, fetchPageBySlug, fetchArticlesPage, fetchArticlePage, fetchEmployee } from "@/graphql/pages";

import { useCore } from '@/stores/core';

export const usePages = defineStore('pages', {
    state: () => {
        return {
            currentEmployeeData: {
                fullname: '',
                position: '',
                bio: '',
                linkedin: '',
                photo: ''
            },

            currentPage: {
                categories: [],
                event: {},
                events: [],

                event: {
                    dates: [],
                    type: '',
                    animator: '',
                    duration: '',
                    registration_fee: null,
                    registration_fee_euro: null,
                    total: null,
                    total_euro: null,
                },
                
                training: {
                    dates: [],
                    category: '',
                    duration: '',
                    prerequisites: '',
                    registration_fee: null,
                    registration_fee_euro: null,
                    total: null,
                    total_euro: null,
                },

                trainings: [],
                sections: [],
            },

            pageBySlug: {
                trainings: [],
            }
        };
    },

    // Actions
    actions: {
        async fetchCurrentPage(slug, options) {
            return new Promise((resolve, reject) => {                                      
                const core = useCore();

                if (options && options.trainings_and_dates == 'trainings') {
                    var query = useQuery(fetchCurrentPage, { slug: slug, trainings_and_dates: 'trainings', region: core.region });
                } else if (options && options.categories == 'all') {
                    var query = useQuery(fetchCurrentPage, { slug: slug, categories: 'all', region: core.region });
                } else if (options && options.events_and_dates == 'events') {
                    var query = useQuery(fetchCurrentPage, { slug: slug, events_and_dates: 'events', region: core.region });
                } else if (options && options.meetings_and_dates == 'andc') {
                    var query = useQuery(fetchCurrentPage, { slug: slug, meetings_and_dates: 'andc', region: core.region });
                } else if (options && options.trainings_and_dates == 'advanced_trainings') {
                    var query = useQuery(fetchCurrentPage, { slug: slug, trainings_and_dates: 'advanced_trainings', region: core.region });
                } else {
                    var query = useQuery(fetchCurrentPage, { slug: slug, region: core.region });
                }
                
                query.onError((error) => reject(error));
                
                query.onResult((result) => {       
                    this.currentPage = result.data.page;
                    resolve();
                });
            });
        },

        async fetchPageBySlug(slug, options) {
            return new Promise((resolve, reject) => {                                      
                var query = useQuery(fetchPageBySlug, { 
                    slug: slug, 
                    trainings_and_dates: 'trainings',
                    region: options.region
                });

                query.onError((error) => reject(error));
                
                query.onResult((result) => {       
                    this.pageBySlug = result.data.page;
                    resolve();
                });
            });
        },

        
        async fetchArticlesPage(slug) {
            return new Promise((resolve, reject) => {                
                const query = useQuery(fetchArticlesPage, { slug: slug, limit: 0 });

                query.onError((error) => reject(error));
                
                query.onResult((result) => {       
                    this.currentPage = result.data.page;
                    resolve();
                });
            });
        },

        async fetchArticlePage(slug) {
            return new Promise((resolve, reject) => {                
                const query = useQuery(fetchArticlePage, { slug: slug });

                query.onError((error) => reject(error));
                
                query.onResult((result) => {       
                    this.currentPage = result.data.article;

                    resolve();
                });
            });
        },

        async fetchEmployee(category, slug) {
            return new Promise((resolve, reject) => {                
                const query = useQuery(fetchEmployee, { category: category,  slug: slug });

                query.onError((error) => reject(error));
                
                query.onResult((result) => {       
                    this.currentEmployeeData = result.data.fetchEmployee;

                    resolve();
                });
            });
        },
    },
});


